const sleep = millis => new Promise(resolve => setTimeout(resolve, millis));

const maxLoopCount = 30;

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // 写真のbinaryRevisionをチェックする
    async checkPhotoBinaryRevision({ dispatch }, { cloud_construction_id, photo_key, binary_revision, wait_before_first_check }){
      if(wait_before_first_check) await sleep(1000); // 1秒待つ

      let receivedBinaryRevision = undefined;

      let i = 0;
      for(;;){
        const apiArgs = {
          cloud_construction_id,  // 工事ID
          photo_keys: [ photo_key ],
          __apiOptions: { noDisplayLoading: true },
        }
        const photoInfoList = await dispatch('api/getPhotoSet', apiArgs, { root: true })
        if(!photoInfoList){
          return 'ERROR';
        }
        const photoInfo = photoInfoList.find(pi => pi.photo_key === photo_key);
        if(photoInfo && photoInfo.photo){
          receivedBinaryRevision = photoInfo.photo.binary_revision
        }

        if(binary_revision === receivedBinaryRevision){
          // 完了
          return 'OK';
        }
        if(receivedBinaryRevision && binary_revision < receivedBinaryRevision){
          // もう古い
          return 'TOO_OLD'
        }
        ++i;
        if(maxLoopCount < i){
          await dispatch("app/updateAppError", {
            customErrorCode: '004',
            description: '写真更新の完了が確認できませんでした'
          }, { root: true });
          return 'ERROR';
        }
        await sleep(1000); // 1秒待つ
      }
    },
    // 黒板のbinaryRevisionをチェックする
    async checkKokubanBinaryRevision({ dispatch }, { cloud_construction_id, kokuban_hash, binary_revision, wait_before_first_check }){
      if(wait_before_first_check) await sleep(1000); // 1秒待つ

      let receivedBinaryRevision = undefined;

      let i = 0;
      for(;;){
        const apiArgs = {
          cloud_construction_id,  // 工事ID
          kokuban_hashes: [ kokuban_hash ],
          __apiOptions: { noDisplayLoading: true },
        }
        const kokubanInfoList = await dispatch('api/getKokubanSet', apiArgs, { root: true })
        if(!kokubanInfoList){
          return 'ERROR';
        }
        const kokubanInfo = kokubanInfoList.find(pi => pi.kokuban_hash === kokuban_hash);
        if(kokubanInfo && kokubanInfo.kokuban){
          receivedBinaryRevision = kokubanInfo.kokuban.binary_revision
        }

        if(binary_revision === receivedBinaryRevision){
          // 完了
          return 'OK';
        }
        if(receivedBinaryRevision && binary_revision < receivedBinaryRevision){
          // もう古い
          return 'TOO_OLD'
        }
        ++i;
        if(maxLoopCount < i){
          await dispatch("app/updateAppError", {
            customErrorCode: '004',
            description: '黒板更新の完了が確認できませんでした'
          }, { root: true });
          return 'ERROR';
        }
        await sleep(1000); // 1秒待つ
      }
    },
  },
}
